import { render, staticRenderFns } from "./SafetyRatings.vue?vue&type=template&id=65d0cc1c&scoped=true&"
import script from "./SafetyRatings.vue?vue&type=script&lang=js&"
export * from "./SafetyRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0cc1c",
  null
  
)

export default component.exports